var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconSupport = function SvgIconSupport(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -194) translate(6 193) translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#4A657B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.087 11.593v-.554c0-3.841-3.134-6.975-6.975-6.975-3.84 0-6.975 3.134-6.975 6.975v.554c-1.222.458-2.101 1.643-2.101 3.019 0 1.777 1.452 3.23 3.229 3.23H8.43c.306 0 .555-.25.555-.555v-5.35c0-.306-.249-.555-.555-.555h-.535v-.343c0-2.886 2.332-5.217 5.217-5.217s5.217 2.331 5.217 5.217v.343h-.535c-.306 0-.555.249-.555.555v5.35c0 .306.249.554.555.554h.248c-.554 1.28-1.777 2.178-3.23 2.293-.076-.363-.4-.65-.802-.65h-1.815c-.459 0-.822.363-.822.822v.936c0 .459.363.822.822.822h1.815c.401 0 .745-.287.803-.688 2.159-.115 3.955-1.586 4.567-3.573 1.566-.21 2.79-1.567 2.79-3.191.018-1.395-.86-2.56-2.083-3.02z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconSupport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-support.bdecdd937f57dc648363ebe37ec04f2f.svg";